"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const navigation_1 = __importDefault(require("@App/navigation"));
const bulk_upload_error_type_1 = require("@App/enum/bulk-upload-error-type");
const bulkErrorStrings = {
    [bulk_upload_error_type_1.BulkUploadErrorType.UNKNOWN]: {
        errorBody: (react_1.default.createElement(react_1.default.Fragment, null,
            "Please contact The MLC Support Team ",
            react_1.default.createElement("a", { href: navigation_1.default.contactUs.root() }, "here"),
            " to resolve this issue.")),
        footer: '',
        header: 'Something has gone wrong',
        subheader: '',
    },
    [bulk_upload_error_type_1.BulkUploadErrorType.PARSE_ERROR]: {
        errorBody: (react_1.default.createElement(react_1.default.Fragment, null,
            "Please contact The MLC Support Team ",
            react_1.default.createElement("a", { href: navigation_1.default.contactUs.root() }, "here"),
            " to resolve this issue.")),
        footer: '',
        header: 'There is a formatting error with your file',
        subheader: '',
    },
    [bulk_upload_error_type_1.BulkUploadErrorType.DUPLICATE_TITLE]: {
        errorBody: "For multiple writers on the same work, completely fill in all necessary columns including the first writer's information. " +
            'Then move to the row below, leave columns A-F blank, and begin the second writer&apos;s info in column G, continuing until all writers are entered.',
        footer: 'Once you have resolved this error, please upload again.',
        header: 'Unique work titles can only appear once per bulk work upload file',
        subheader: '',
    },
    [bulk_upload_error_type_1.BulkUploadErrorType.REQUIRED]: {
        errorBody: undefined,
        footer: 'Please check your bulk work file and ensure that all required fields are filled out. Once resolved, please try again.',
        header: 'It looks like some information is missing or incorrect',
        subheader: 'There are required fields in your file that appear to be empty or have incorrect data.',
    },
    [bulk_upload_error_type_1.BulkUploadErrorType.FILE_TOO_LARGE]: {
        header: 'Your file is too large',
        subheader: 'At this time, we can accept files with up to 300 lines.',
        errorBody: undefined,
        footer: 'Please break down your works data into smaller files and try uploading again.',
    },
};
exports.default = bulkErrorStrings;
